module.exports = __webpack_public_path__ + "img/0db765074d7a3ba1832425684a9ac18.8452295c.png";